<template>
	<div class="finance-tab">
		<div v-if="categoryTabs" class="all-budgets">
			<div class="budget-creator">
				<div
					v-for="(categoryTab, index) in categoryTabs"
					:key="index"
					class="category-cnt"
					:class="{ expanded: categoryTab.expanded }"
				>
					<div
						class="category-header"
						role="button"
						tabindex="0"
						:aria-label="
							$t('categoryBudgetSummary', {
								category: categoryTab.name,
								expenses: categoryTab.expenses,
								budget: categoryTab.budget
							})
						"
						:aria-expanded="(!!categoryTab.expanded).toString()"
						@click="toggleSliders(categoryTab)"
						@keydown.enter="toggleSliders(categoryTab)"
						@keydown.space="toggleSliders(categoryTab)"
						@mousedown.prevent
					>
						<div class="slider-info">
							<div class="body-text-2">{{ categoryTab.name }}</div>
							<div class="heading-4">
								{{ categoryTab.expenses | currency }}/{{
									categoryTab.budget | currency
								}}
							</div>
							<svgicon name="arrow-right"></svgicon>
						</div>
					</div>
					<transition name="slide" mode="out-in">
						<div
							v-if="categoryTab.expanded !== null"
							v-show="categoryTab.expanded"
							class="sliders-cnt"
						>
							<div
								v-for="(subcategory, i) in categoryTab.subcategories"
								:key="i"
								class="slider-wrapper"
								:aria-label="
									$t('categoryBudgetSummary', {
										category: subcategory.name,
										expenses: subcategory.expenses,
										budget: subcategory.budget
									})
								"
							>
								<div class="slider-info" aria-hidden="true">
									<label class="slider-name body-text-2">{{
										subcategory.name
									}}</label>
									<label class="slider-value body-text-2"
										>{{ subcategory.expenses | currency }}/{{
											subcategory.budget | currency
										}}</label
									>
								</div>
								<ja-budget-bar
									aria-hidden="true"
									:value="subcategory.expenses"
									:max-value="subcategory.budget"
									:overflow="subcategory.expenses > subcategory.budget"
								>
								</ja-budget-bar>
							</div>
						</div>
					</transition>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
import ExpenseCategories from '@/mixins/ExpenseCategories';
import BudgetBar from '../ui/BudgetBar';

export default {
	components: {
		jaBudgetBar: BudgetBar
	},
	mixins: [ExpenseCategories],
	mounted() {
		if (this.categoryGroups) {
			this.setCategoryTabs();
		}
	},
	methods: {
		toggleSliders(categoryTab) {
			categoryTab.expanded = !categoryTab.expanded;
		}
	}
};
</script>
<style lang="scss" scoped>
.finance-tab {
	.budget-creator {
		width: 100%;

		.category-cnt {
			width: 100%;
			border-radius: 8px;
			margin-bottom: 16px;
			background-color: $page-bgcolor;

			&.expanded {
				padding-bottom: 24px;
				.category-header {
					svg {
						transform: rotate(270deg);
						transition: transform 0.5s linear;
					}
				}
			}

			&:hover {
				cursor: pointer;

				.category-header {
					svg {
						fill: $hover-state;
					}
				}
			}

			.category-header {
				display: flex;
				flex-flow: column;
				align-items: stretch;

				padding: 24px 16px;

				.slider-info {
					display: flex;

					.svg-icon {
						align-self: center;
					}
				}

				.body-text-2 {
					flex-grow: 1;
					text-align: left;
				}

				.heading-4 {
					margin: 0;
					margin-right: 16px;
				}

				svg {
					transform: rotate(90deg);
					transition: transform 0.5s linear;
					width: 6px;
					height: 10px;
					fill: $primary-state;
				}
			}

			.sliders-cnt {
				padding: 16px 32px;
				position: relative;

				.slider-wrapper {
					&:not(:first-child) {
						margin-top: 16px;
					}
					.slider-info {
						display: flex;
					}

					.slider-name {
						flex-grow: 1;
						text-align: left;
						text-transform: capitalize;
					}
					.budget-bar {
						margin-top: 8px;
					}
				}
			}
		}
		.slide-enter {
			transform: scaleY(0);
		}

		.slide-enter-active {
			transition: transform 0.5s ease;
			transform-origin: top;
		}

		.slide-leave-to {
			transform: scaleY(0);
		}

		.slide-leave-active {
			transition: transform 0.3s ease;
			transform-origin: top;
		}
	}
}
</style>
